<template>
    <div class="box-upload-container" v-if="isShowDialog">
        <div class="d-flex align-center justify-space-between" style="height: 50px">
            <div style="font-size: 18px; font-weight: bold; color: #1F1F1F; padding-left: 15px;">
                Dữ liệu tải lên {{ countSuccess }} / {{ progressFiles.length }} mục
            </div>
            <v-btn icon @click="handleCancelAll">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <div>
            <div class="d-flex align-center justify-space-between" v-for="file in progressFiles" :key="file.id"
                style="padding-right: 15px; padding-left: 15px; margin-top: 15px;">
                <div class="d-flex align-center">
                    <div class="type-data">
                        {{ file.type }}
                    </div>
                    <div>
                        <div style="font-size: 18px;">{{ file.name }}</div>
                        <div v-if="file.error_message" style="color: #B03A2E; font-size: 14px;">{{ file.error_message }}
                        </div>
                    </div>

                </div>

                <div>
                    <v-progress-circular v-if="!file.isDone" :size="25" :width="3" indeterminate
                        color="primary"></v-progress-circular>
                    <div v-else>
                        <v-icon v-if="file.isError" style="color: #E91E63">mdi-information</v-icon>
                        <v-icon v-else style="color: green">mdi-checkbox-marked-circle</v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ConfirmBuilder } from '@utils'

export default {
    name: "box-upload",
    computed: {
        ...mapGetters({
            isShowDialog: "datastore/isShowDialog",
            progressFiles: "datastore/progressFiles",
        }),
        countDone() {
            return this.progressFiles.filter((x) => x.isDone).length;
        },
        countSuccess() {
            return this.progressFiles.filter((x) => !x.isError && x.isDone).length;
        },
    },
    watch: {
        progressFiles(val){
            console.log(val)
        }
    },
    methods: {
        async handleCancelAll() {
            if (this.countDone < this.progressFiles.length) {
                let confirm = new ConfirmBuilder()
                confirm
                    .addMessage('Bạn có chắc chắn muốn hủy toàn bộ quá trình tải dữ liệu')
                    .setTitle('Hủy tải dữ liệu')
                    .setType('delete')
                if (await confirm.confirm()) {
                    this.$store
                        .dispatch('datastore/cancelAll')
                        .then((res) => {

                        })
                }
            } else this.$store
                .dispatch('datastore/cancelAll')

        }
    }

};
</script>
<style scoped>
.d-flex {
    display: flex;
}

.align-center {
    align-items: center;
}

.justify-space-between {
    justify-content: space-between;
}

.box-upload-container {
    width: 350px;
    position: fixed;
    background: white;
    bottom: 40px;
    right: 10px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    padding-bottom: 20px;
}

.type-data {
    padding: 3px;
    padding-left: 6px;
    padding-right: 6px;
    width: 65px;
    border: 1px solid #0E6655;
    border-radius: 16px;
    margin-right: 20px;
    font-size: 13px;
    color: #935116;
    text-align: center;
}
</style>
  